<template>
  <div>
    <div class="privacy-container">
      <slider></slider>
      <div class="box-wrapper">
        <div class="title">
          PRIVACY & TERMS
        </div>
        <div class="content">
          <ul
            v-for="parent in $t('message.privacy.content')"
            :key="parent.title"
          >
            <li>{{ parent.title }}</li>
            <ul>
              <li v-for="child in parent.child" :key="child">
                {{ child }}
              </li>
            </ul>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Slider from "../../components/SliderWhite";
export default {
  name: "available",
  components: {
    // Section1
    Slider
  }
};
</script>

<style lang="scss" scoped>
@import "@scss/privacy/privacy.scss";
</style>